/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Filter_Created_ToInputs */

const cs_blog_filter_created_to = /** @type {(inputs: Blog_Filter_Created_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořeno do`)
};

const en_blog_filter_created_to = /** @type {(inputs: Blog_Filter_Created_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created to`)
};

/**
* | output |
* | --- |
* | "Created to" |
*
* @param {Blog_Filter_Created_ToInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_filter_created_to = /** @type {((inputs?: Blog_Filter_Created_ToInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Filter_Created_ToInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_filter_created_to(inputs)
	return cs_blog_filter_created_to(inputs)
});